import { memo } from 'react';

import CalendarCheckedIconSVG from '@/assets/calendar-checked-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const ICalendarCheckedIcon = (props: Omit<IconProps, 'SVGComponent'>) => (
  <Icon SVGComponent={CalendarCheckedIconSVG} {...props} />
);

export const CalendarCheckedIcon = memo(ICalendarCheckedIcon) as typeof ICalendarCheckedIcon;
